/**
 * Firestore implementation of MeasurementOpeningRepository.
 *
 * Path: measurements/{mcId}/openings/{openingId}  (openingId = UUID = doc id)
 *
 * A subcollection on purpose (council B1): invisible to the parent-collection
 * list() reads every dashboard load does, per-opening phone writes, its own
 * rules match block. Soft-deleted openings (removedAt set) are RETURNED here —
 * filtering is the service's job, because the expansion idempotency key must
 * see them (a soft-deleted opening must not be recreated by re-generate).
 */
import { collection, doc, getDoc, getDocs, setDoc } from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import type { EntityId, MeasurementOpening } from '../../../types';
import type { MeasurementOpeningRepository } from '../types';

const PARENT = 'measurements';
const SUB = 'openings';

export const firestoreMeasurementOpeningRepository: MeasurementOpeningRepository = {
  async listByMc(mcId: EntityId): Promise<MeasurementOpening[]> {
    const snap = await getDocs(collection(db, PARENT, mcId, SUB));
    return snap.docs.map((d) => d.data() as MeasurementOpening);
  },

  async findById(mcId: EntityId, openingId: EntityId): Promise<MeasurementOpening | null> {
    const snap = await getDoc(doc(db, PARENT, mcId, SUB, openingId));
    return snap.exists() ? (snap.data() as MeasurementOpening) : null;
  },

  async save(mcId: EntityId, opening: MeasurementOpening): Promise<void> {
    await setDoc(doc(db, PARENT, mcId, SUB, opening.openingId), opening);
  },
};
